import type { AnyFormApi } from '@tanstack/vue-form'

const isRegistered = (fieldNames: readonly string[], path: string): boolean =>
  fieldNames.some((name) => name === path)

/** Blur verdicts at unregistered paths are re-derived by the submit pass; submit verdicts stay until it replaces them. */
const clearUnregisteredBlurVerdicts = (form: AnyFormApi, fieldNames: readonly string[]): void => {
  for (const path of Object.keys(form.state.fieldMeta)) {
    if (isRegistered(fieldNames, path)) continue
    form.setFieldMeta(path, (meta) => ({
      ...(meta ?? {}),
      errorMap: { ...meta?.errorMap, onBlur: undefined }
    }))
  }
}

/** Re-validates every field and the form first, so a verdict left by an earlier blur or submit never blocks a fixed form; the real submit then runs with every validator active. */
export const submitFormClearingStaleVerdicts = async (
  form: AnyFormApi,
  fieldNames: readonly string[]
): Promise<void> => {
  clearUnregisteredBlurVerdicts(form, fieldNames)
  await form.validate('submit')
  await form.handleSubmit()
}
